import { render, staticRenderFns } from "./PaymentsGrid.vue?vue&type=template&id=ebf3663e&scoped=true&"
import script from "./PaymentsGrid.vue?vue&type=script&lang=js&"
export * from "./PaymentsGrid.vue?vue&type=script&lang=js&"
import style0 from "./PaymentsGrid.vue?vue&type=style&index=0&id=ebf3663e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebf3663e",
  null
  
)

export default component.exports